const LocalStorage = {

    getUser: function () {
        if (typeof window !== 'undefined') {
            var user = JSON.parse(window.localStorage.getItem("b2b2cUser"))
            if (user) {
                return user
            }
        }
        return null
    }
    ,

    setUser: function (user) {
        if (typeof window !== 'undefined') {
            window.localStorage.setItem("b2b2cUser", JSON.stringify(user))
            var user = JSON.parse(window.localStorage.getItem("b2b2cUser"))
            if (user) {
                return true
            }
        }
        return false
    },

    deleteUser: function () {
        if (typeof window !== 'undefined') {
            window.localStorage.removeItem("b2b2cUser")
            return true
        }
        return false
    },

    setData: function (key, data) {
      console.log('setData ', key, data, typeof window !== 'undefined', typeof data, JSON.stringify(data));
      if (typeof window !== 'undefined') {
          window.localStorage.setItem(key, typeof data == 'object' ? JSON.stringify(data) : data)
          return true
      }
      return false
    },

    getData: function (key) {
      console.log('getData ', key);
        if (typeof window !== 'undefined') {
            let data = window.localStorage.getItem(key)
            if(data) return data
        }
        return null
    },

    deleteData: (key) => {
      try {
        if(key) localStorage.removeItem(key);
        return true;
      } catch (e) {
        return false;
      }
    }
}

export default LocalStorage
